import type { JSX } from 'react'

import { NotificationToastsContainer } from "/app/libraries/arcana/src/atoms/NotificationToast/index.ts"

import { useUnit } from 'effector-react'
import * as notificationToastsModel from './model'

export function NotificationToasts(): JSX.Element | null {
  const toasts = useUnit(notificationToastsModel.$toasts)
  const hideToast = useUnit(notificationToastsModel.hideToast)

  return <NotificationToastsContainer toasts={toasts} onClose={hideToast} />
}
